import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';


export interface EmailConditionBlock {
    title: string;
    conditions: EmailCondition[]
}



@JsonObject('model.EmailCondition')
export class EmailCondition extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'clazz')
    clazz?: string;

    @JsonProperty(Boolean, 'active')
    active?: boolean;

    @JsonProperty(String, 'clientMsg')
    clientMsg?: string;

    @JsonProperty(String, 'clientSubject')
    clientSubject?: string;

    @JsonProperty(String, 'msg')
    msg?: string;

    @JsonProperty(String, 'title')
    title?: string;
}
